import { Injectable } from '@angular/core';
import {CrudSettings, QueryParams} from "../shared/crud/abstractions/base-crud";
import {ApiResourceDto, CreateApiResourceDto, EditApiResourceDto} from "./models/ApiResourceDtos";
import {BasePagedCrudService} from "../shared/crud/base-crud.service";
import { HttpClient } from "@angular/common/http";
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

class ApiResourceCrudSettings implements CrudSettings<string, ApiResourceDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix: string | undefined;
  deleteSuffix: string | undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix: string | undefined;
  editMethod: 'PUT' | 'PATCH' = 'PATCH';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'all';
  getSuffix: string | undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';

  idGetter(entity: ApiResourceDto): string {
    return entity.id;
  }

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);

    return {params: dict}
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.baseUrl + '/api/IdentityServer/ApiResource';
  }
}

@Injectable({
  providedIn: null
})
export class ApiResourceDataService extends BasePagedCrudService<string, ApiResourceDto, CreateApiResourceDto, EditApiResourceDto>{

  constructor(http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(http, new ApiResourceCrudSettings(environmentService),dialogService)
  }
}
